import { render, staticRenderFns } from "./TrainConfigsAndModels.vue?vue&type=template&id=00643d05&scoped=true"
import script from "./TrainConfigsAndModels.vue?vue&type=script&lang=js"
export * from "./TrainConfigsAndModels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00643d05",
  null
  
)

export default component.exports